import React from 'react';
export const CustomChevronIcon = ({ className }) => (React.createElement("div", { className: className },
    React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M8.29688 16.59L12.8769 12L8.29688 7.41L9.70687 6L15.7069 12L9.70687 18L8.29688 16.59Z", fill: "black" }))));
//# sourceMappingURL=ChevronIcon.js.map